module.exports = __webpack_public_path__ + "static/media/chevron-up-gray.9d401f8d.svg";